/**
 * projetosKit — constantes e helpers compartilhados do módulo Projetos.
 *
 * O Kanban de tarefas reusa as classes CSS kbc- e kanban- (globals.css) e os
 * estilos de drawer/painel do panelKit do Comercial. Aqui ficam só os mapas de
 * cor, rótulos de status/prioridade e utilidades de formatação específicas.
 */

export { fmtDate, fmtDateTime } from '../comercial/panelKit.jsx'

export const PRIO_ORDER = ['baixa', 'media', 'alta', 'urgente']
export const PRIO_LABEL = { baixa: 'Baixa', media: 'Média', alta: 'Alta', urgente: 'Urgente' }

// Badge de prioridade (fundo tintado + texto na cor), retângulo arredondado —
// cores amostradas do conceito `titam-crm-projetos-conceito-v1.png`.
export const PRIO_BADGE = {
  baixa: { bg: '#f2f4f7', fg: '#667085' },
  media: { bg: '#eef4ff', fg: '#2563eb' },
  alta: { bg: '#fff4e5', fg: '#b54708' },
  urgente: { bg: '#fdeceb', fg: '#d92d20' },
}

// Acento das colunas do quadro (barra vertical no cabeçalho). A 1ª coluna fica
// sem acento e a coluna de ganho usa verde — igual ao conceito.
export const COL_ACCENTS = ['#2563eb', '#7c3aed', '#b54708', '#0891b2', '#4f46e5', '#db2777']
export const COL_ACCENT_WON = '#12805c'

const MESES_ABREV = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']

// Data curta ("16 ago.") usada nos cards de tarefa e no cabeçalho do projeto.
export function fmtDateShort(v) {
  if (!v) return null
  const d = new Date(v)
  if (isNaN(d)) return null
  return `${String(d.getDate()).padStart(2, '0')} ${MESES_ABREV[d.getMonth()]}.`
}

// Tarefa vencida: tem prazo, já passou e ainda não foi concluída.
export function isOverdue(task) {
  if (!task?.prazo || task.status === 'concluido') return false
  return new Date(task.prazo).getTime() < Date.now()
}

// Status macro do projeto (saúde) — NÃO é a coluna do Kanban.
export const PROJECT_STATUS = ['ativo', 'pausado', 'concluido', 'arquivado']
export const PROJECT_STATUS_COLORS = {
  ativo: '#2563eb', pausado: '#b54708', concluido: '#12805c', arquivado: '#667085',
}
export const PROJECT_STATUS_LABEL = {
  ativo: 'Ativo', pausado: 'Pausado', concluido: 'Concluído', arquivado: 'Arquivado',
}

// Iniciais p/ avatar de responsável a partir de nome/email/id.
export function initials(s) {
  if (!s) return '?'
  const parts = String(s).trim().split(/[\s@.]+/).filter(Boolean)
  if (!parts.length) return '?'
  return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase()
}

// Cor de avatar estável por id (hash simples → paleta fixa), p/ cada
// responsável ter sempre a mesma cor nos cards, header e painel de tarefa.
const AVATAR_PALETTE = ['#2563eb', '#12805c', '#b54708', '#7c3aed', '#d92d20', '#0891b2', '#4f46e5', '#db2777']
export function avatarColor(id) {
  if (!id) return AVATAR_PALETTE[0]
  let h = 0
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0
  return AVATAR_PALETTE[h % AVATAR_PALETTE.length]
}

// % concluído a partir de contadores da lista de projetos.
export function pctDone(done, total) {
  const t = Number(total) || 0
  if (!t) return 0
  return Math.round((Number(done) || 0) / t * 100)
}
